




























































































import { Component, Mixins, Watch, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import { InquiryDiv as InquiryDivModel } from "@/model/inquiry";
import { VForm } from "@/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import AppIconButton from "@/components/admin_common/AppIconButton.vue";

@Component({
  components: {
    AppAuthButton,
    AppIconButton,
  },
})
export default class InquiryDiv extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** Ref */
  @Ref("form") private readonly form!: VForm;

  private dialog = false;
  private valid = false;
  private inquiryDivs: InquiryDivModel[] = [];
  private editedIndex = -1;
  private editedItem: InquiryDivModel = {
    id: 0,
    name: "",
    sort_no: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
  };
  private defaultItem: InquiryDivModel = {
    id: 0,
    name: "",
    sort_no: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
  };

  private headers = [
    { text: "ID", value: "id" },
    { text: "並び順", value: "sort_no" },
    { text: "問い合わせ種類名", value: "name" },
    { text: "操作", value: "actions", sortable: false },
  ];

  get formTitle() {
    return this.editedIndex === -1 ? "新規追加" : "編集";
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    val || this.close();
  }

  created() {
    this.fetchData();
  }

  private fetchData() {
    this.postJsonCheck(
      window.base_url + "/api/admin/inquiry_master/inquiry_div/get",
      {},
      (res) => {
        if (res.data && res.data.inquiry_divs) {
          this.inquiryDivs = res.data.inquiry_divs;
        }
      }
    );
  }

  private editItem(item: InquiryDivModel) {
    this.editedIndex = this.inquiryDivs.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  private async deleteItem(item: InquiryDivModel) {
    if (await this.$openConfirm("削除しますか？")) {
      this.postJsonCheck(
        window.base_url + "/api/admin/inquiry_master/inquiry_div/delete",
        { inquiry_div: item },
        () => {
          this.fetchData();
        }
      );
    }
  }

  private close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      if (this.form) {
        this.form.resetValidation();
      }
    });
  }

  private save() {
    if (!this.form.validate()) {
      return;
    }

    const url = window.base_url + "/api/admin/inquiry_master/inquiry_div/save";
    this.postJsonCheck(url, { inquiry_div: this.editedItem }, () => {
      this.fetchData();
      this.close();
    });
  }
}
